import DatePicker from "react-datepicker";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import FloatingInput from "./date-time-input/FloatingInput";
import {
  FieldTypes,
  IField,
} from "@/api/AppApi/services/builder/interfaces/interfaces";
import { validateFormController } from "../../form-builder-helpers/form-functions";
import { DateDisplayFormats } from "@/utils/functions/date-time-functions";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  field: IField;
  form: UseFormReturn<FieldValues, any>;
  minDate?: Date;
}
const CommonDateTimeInput: React.FC<Props> = ({ form, field, minDate }) => {
  const t = useTranslation();
  const fConfig = field.configurations;
  const dateFormat =
    fConfig.type === FieldTypes.date
      ? DateDisplayFormats.date
      : fConfig.type === FieldTypes.time
      ? DateDisplayFormats.time
      : DateDisplayFormats.data_time;
  const DatePic: any = DatePicker;
  return (
    <Controller
      control={form.control}
      name={`${fConfig.key}.value`}
      rules={{
        validate: (value) =>
          validateFormController({
            form,
            fieldName: fConfig.key,
            value,
            is_required: fConfig?.is_required,
            requiredMsg: t.this_field_is_required,
          }),
      }}
      render={({ field }) => (
        <DatePic
          minDate={minDate}
          className={`${fConfig.type !== FieldTypes.time ? "time-picker" : ""}`}
          dateFormat={dateFormat}
          onChange={(date: Date | null) => {
            field.onChange(date);
          }}
          selected={field.value}
          customInput={
            <FloatingInput
              label={fConfig.title}
              type={fConfig.type}
              isRequired={fConfig.is_required}
              errorMsg={form.formState.errors[fConfig.key]?.message as string}
              hideLabel={fConfig.hideLabel}
              hint={fConfig.hint}
            />
          }
          clearButtonClassName="date-clear"
          isClearable
          showYearDropdown={fConfig.type !== FieldTypes.time}
          yearDropdownItemNumber={50}
          scrollableYearDropdown
          showTimeSelectOnly={fConfig.type === FieldTypes.time}
          showTimeInput={[FieldTypes.time, FieldTypes.date_time].includes(
            fConfig.type,
          )}
        />
      )}
    />
  );
};

export default CommonDateTimeInput;
